
















































import { get, isEmpty } from 'lodash';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoImage from '../../Atoms/co-image/CoImage.vue';

interface Label {
    imageURL?: string;
    color?: string;
    icon?: string;
}

export default {
    name: 'CoThumbnail',
    components: {
        CoIcon,
        CoImage,
    },
    props: {
        imageURL: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
        round: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: true,
        },
        contentType: {
            type: String,
            default: 'image',
            validator: (value: string) => ['image', 'user', 'page', 'event', 'color', 'icon'].includes(value),
        },
        color: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: 'md',
            validator: (value: string) => ['xs', 'sm', 'ms', 'md', 'lg', 'xl', 'label'].includes(value),
        },
        deletable: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: Boolean,
            default: true,
        },
        label: {
            type: Object as () => Label,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        altText: {
            type: String,
            default: '',
        },
    },
    computed: {
        url() {
            if (!this.imageURL) {
                return '';
            }

            //  if starts with https://cdnmedia.coapp.io/ or https://media.coapp.io/ return as is
            if (
                this.imageURL.startsWith('https://cdnmedia.coapp.io/') ||
                this.imageURL.startsWith('https://media.coapp.io/')
            ) {
                return this.imageURL;
            }
            // if imageURL starts with https://collaborates.s3.eu-central-1.amazonaws.com/ remove from url
            let tmp = this.imageURL;
            if (this.imageURL && this.imageURL.startsWith('https://collaborates.s3.eu-central-1.amazonaws.com/')) {
                tmp = tmp.replace('https://collaborates.s3.eu-central-1.amazonaws.com/', '');
            } else if (
                this.imageURL &&
                this.imageURL.startsWith('https://projects-headers.s3.eu-central-1.amazonaws.com/')
            ) {
                tmp = tmp.replace('https://projects-headers.s3.eu-central-1.amazonaws.com/', '');
            } else {
                return this.imageURL;
            }

            // replace / with _ in the url
            tmp = tmp.replace(/\//g, '_');

            //  and new prefix https://cdnmedia.coapp.io/legacy/images/
            tmp = `https://cdnmedia.coapp.io/legacy/images/${tmp}?w=200`;

            return tmp;
        },
        classes() {
            return {
                clickable: this.clickable,
                deletable: this.deletable,
                round: this.round,
                [`size-${this.size}`]: true,
                'has-label': this.label && !isEmpty(this.label) ? true : false,
            };
        },
        placeholderSize() {
            switch (this.size) {
                case 'label':
                    return '75%';
                case 'sm':
                    return '.6rem';
                case 'ms':
                    return '.67rem';
                default:
                    return '1rem';
            }
        },
    },
    methods: {
        get,
        isEmpty,
        click(event) {
            if (this.link) {
                // stop the click event from propagating to the parent element
                event.stopPropagation();
                this.$router.push(this.link);
                return;
            }

            if (this.clickable) {
                this.$emit('click', event);
            }
        },
    },
};
